module.exports = __webpack_public_path__ + "media/images/countrysquared/ie-1ca66ddd49244737a4b49fb68ada3b2f.svg";